import { TableContainer } from "../../../DemandaCriada/styles";
import { Parte } from "../../../DemandaCriada/types";
import { Check, X } from "lucide-react";
import styled from "styled-components";

const ParteHeader = styled.div<{ tipo: 'adicionada' | 'removida' }>`
    background-color: rgba(0, 0, 0, 0.03);
    padding: 6px 8px;
    font-size: 9px;
    font-weight: 500;
    text-transform: uppercase;
    color: var(--c64748b);
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    gap: 6px;
    
    .tipo-alteracao {
        font-weight: 600;
        color: ${({ tipo }) => {
            switch (tipo) {
                case 'adicionada':
                    return '#2E86DE';
                case 'removida':
                    return '#E5293F';
                default:
                    return '#64748B';
            }
        }};
    }
`;

interface CardParteProcessoEditadaProps {
    parte: Parte;
    tipoAlteracao: 'adicionada' | 'removida';
}

export default function CardParteProcessoEditada({ parte, tipoAlteracao }: CardParteProcessoEditadaProps) {
    const getTipoLabel = (tipo: 'adicionada' | 'removida'): string => {
        switch (tipo) {
            case 'adicionada':
                return 'ADICIONADA';
            case 'removida':
                return 'REMOVIDA';
            default:
                return '';
        }
    };

    return (
        <TableContainer>
            <ParteHeader tipo={tipoAlteracao}>
                <span>PARTES DO PROCESSO</span>
                <span>•</span>
                <span className="tipo-alteracao">{getTipoLabel(tipoAlteracao)}</span>
            </ParteHeader>
            <table className="data-table">
                <thead>
                    <tr>
                        <th className="field-col">Campo</th>
                        <th className="value-col">Valor</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="field-cell">Tipo</td>
                        <td className="value-cell">{parte.tipo}</td>
                    </tr>
                    <tr className="border-top">
                        <td className="field-cell">Nome</td>
                        <td className="value-cell">{parte.nome}</td>
                    </tr>
                    <tr className="border-top">
                        <td className="field-cell">Parte Representada</td>
                        <td className="value-cell">
                            {parte.representada ? (
                                <Check className="check-icon" />
                            ) : (
                                <X className="x-icon" />
                            )}
                        </td>
                    </tr>
                </tbody>
            </table>
        </TableContainer>
    );
}

